import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const PROVIDER_CORE_FIELDS = gql`
  fragment ProviderCoreFields on Provider {
    id
    name
    emoji
    providerType
    address
    phoneNumber
    startOn
    endOn
    notes
    value: id
    label: name
  }
`;

export const PROVIDER_FIELDS = gql`
  ${PROVIDER_CORE_FIELDS}
  fragment ProviderFields on Provider {
    ...ProviderCoreFields
    client { id, name }
  }
`;

export const PROVIDER = gql`
  ${PROVIDER_FIELDS}
  query Provider($id: ID!) {
    provider(id: $id) {
      ...ProviderFields
    }
  }
`;

export const PROVIDERS = gql`
  ${PROVIDER_FIELDS}
  query Providers (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    providers (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...ProviderFields
        }
      }
      totalCount
    }
  }
`;

export const SUGGEST_PROVIDERS = gql`
  ${PROVIDER_FIELDS}
  query SuggestProviders (
    $clientId: ID
    $eventTypeId: ID
    $eventId: ID
    $all: Boolean
  ) {
    providers: suggestProviders (
      clientId: $clientId
      eventTypeId: $eventTypeId
      eventId: $eventId
      all: $all
    ) {
      ...ProviderFields
    }
  }
`;

export const CREATE_PROVIDER = gql`
  ${PROVIDER_CORE_FIELDS}
  mutation CreateProvider ($input: CreateProviderInput!) {
    createProvider (input: $input) {
      provider {
        ...ProviderCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  ${PROVIDER_CORE_FIELDS}
  mutation UpdateProvider ($input: UpdateProviderInput!) {
    updateProvider (input: $input) {
      provider {
        ...ProviderCoreFields
      }
      ${ERRORS}
    }
  }
`;
